// import { createStore, applyMiddleware } from 'redux';
// import thunk from 'redux-thunk';
// import { createReducer } from './reducers';
// const store = createStore(createReducer(), applyMiddleware(thunk));
// export default store;
import { configureStore } from '@reduxjs/toolkit';
import { createReducer } from './reducers';
const store = configureStore({
    // Automatically calls `combineReducers`
    reducer: createReducer(),
});
export default store;
